export default "__VITE_ASSET__BZCzvVqe__"